"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e, jsxs as o } from "react/jsx-runtime";
import { useTheme as c } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as i } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: n, size: l = 24 } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const h = s(), a = n !== null && n !== void 0 ? n : h ? i.colors.inverse : i.colors.neutralHigh, { skinName: r } = c();
    return r.match(/^blau/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ e("path", {
            fill: a,
            d: "M12 20.637c-4.601 0-8.637-4.036-8.637-8.637S7.399 3.363 12 3.363c4.6 0 8.637 4.036 8.637 8.637 0 4.6-4.036 8.637-8.637 8.637M12 2C6.673 2 2 6.673 2 12s4.673 10 10 10 10-4.673 10-10S17.327 2 12 2m-.678 10.038L8.9 9.616a.506.506 0 1 1 .716-.716l2.422 2.422L14.46 8.9a.506.506 0 1 1 .715.716l-2.421 2.422 2.421 2.422a.506.506 0 0 1-.716.716l-2.421-2.422-2.423 2.422a.506.506 0 1 1-.716-.716z"
        })
    })) : r.match(/^o2-new/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: a,
                d: "M15.78 7.208a.72.72 0 0 1 1.012 0 .72.72 0 0 1 0 1.012L13.012 12l3.772 3.78a.72.72 0 0 1 0 1.012.72.72 0 0 1-.504.212.73.73 0 0 1-.504-.212l-3.78-3.78-3.78 3.78a.7.7 0 0 1-1.008 0 .72.72 0 0 1 0-1.012l3.78-3.78-3.78-3.78a.72.72 0 0 1 0-1.012.72.72 0 0 1 1.012 0l3.78 3.78z"
            }),
            /* @__PURE__ */ e("path", {
                fill: a,
                d: "M12 2C6.484 2 2 6.484 2 12s4.484 10 10 10 10-4.484 10-10S17.516 2 12 2m0 18.576c-4.728 0-8.576-3.848-8.576-8.576S7.272 3.424 12 3.424 20.576 7.272 20.576 12 16.728 20.576 12 20.576"
            })
        ]
    })) : r.match(/^o2/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: a,
                d: "M15.78 7.208a.72.72 0 0 1 1.012 0 .72.72 0 0 1 0 1.012L13.012 12l3.772 3.78a.72.72 0 0 1 0 1.012.72.72 0 0 1-.504.212.73.73 0 0 1-.504-.212l-3.78-3.78-3.78 3.78a.7.7 0 0 1-1.008 0 .72.72 0 0 1 0-1.012l3.78-3.78-3.78-3.78a.72.72 0 0 1 0-1.012.72.72 0 0 1 1.012 0l3.78 3.78z"
            }),
            /* @__PURE__ */ e("path", {
                fill: a,
                d: "M12 2C6.484 2 2 6.484 2 12s4.484 10 10 10 10-4.484 10-10S17.516 2 12 2m0 18.576c-4.728 0-8.576-3.848-8.576-8.576S7.272 3.424 12 3.424 20.576 7.272 20.576 12 16.728 20.576 12 20.576"
            })
        ]
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ e("path", {
            fill: a,
            d: "M23 12.003C23 4.513 18.946 1 11.997 1 5.047 1 1 4.512 1 12.003 1 19.497 5.048 23 11.997 23 18.947 23 23 19.497 23 12.003m-11.003 9.623c-6.474 0-9.623-3.15-9.62-9.623 0-6.48 3.146-9.629 9.623-9.629s9.626 3.153 9.626 9.63c0 6.473-3.153 9.622-9.63 9.622m5.365-14.994c.27.269.27.704 0 .97L12.964 12l4.395 4.395a.688.688 0 1 1-.958.99l-4.407-4.411-4.383 4.382a.687.687 0 0 1-.97.003l-.003-.003a.69.69 0 0 1 0-.974L11.02 12 6.638 7.618a.684.684 0 0 1-.035-.97.684.684 0 0 1 .97-.035l4.418 4.417 4.395-4.395a.69.69 0 0 1 .976-.003"
        })
    }));
}, g = m;
export { g as default };
